import React, {Component} from "react"
import styles from "./Header.module.css"
import edularLogo from "./parts/img/edular-logo.jpg"
import {ReactComponent as SignatureIcon} from "./parts/img/signature.svg"

interface Props {}

export class Header extends Component<Props, {}> {
    public render() {
        return (
            <header className={styles.root}>
                <div className={styles.wrapper}>
                    <h1 className={styles.h1}>
                        <img src={edularLogo} alt="edular-logo" className={styles.imgLogo} />
                    </h1>
                    <div className={styles.rightWrapper}>
                        <SignatureIcon className={styles.signatureIcon} />
                        <span className={styles.text}>APPLY TO DEMO’S</span>
                    </div>
                </div>
            </header>
        )
    }
}
